import { ArtistVerified } from "@enums/artistVerified";
import defaultImage from "@images/shared/profile-default.png";
import { IArtist } from "@interfaces/artist";
import { TArtistDto } from "types/Artist/artistDto";
import { timestampToString } from "./dates.format";
import { booleanToString, getCategoriesFromArray } from "./string";
import { ArtistVerifiedMap } from "./verified.helper";

export const shortenWalletAddress = (address: string): string =>
  `${address.slice(0, 6)}…${address.slice(address.length - 4, address.length)}`;

export const getArtistDisplayName = (
  name: string,
  ens: string,
  walletAddres: string
) => {
  return !ens && !name ? shortenWalletAddress(walletAddres) : name ? name : ens;
};

export const getLabelName = (
  walletAddres: string,
  artistName?: string,
  ensName?: string
) => {
  const nameArtist = artistName || ensName;

  return (
    nameArtist
      ? `${nameArtist} - ${shortenWalletAddress(walletAddres)}`
      : walletAddres
  ).toUpperCase();
};

export const apiArtistToDto = ({
  artistName,
  ensName,
  walletAddress,
  verified,
  avatarUrl,
  description,
  banned,
  createdAt,
  category,
  featured,
}: IArtist): TArtistDto => ({
  artistName: artistName ?? "-",
  ensName: ensName ?? "-",
  walletAddress,
  verified: verified
    ? ArtistVerifiedMap[verified]
    : ArtistVerifiedMap[ArtistVerified.NotVerified],
  avatarUrl: avatarUrl ?? defaultImage,
  description: description ?? "-",
  banned: booleanToString(banned),
  createdAt: timestampToString(createdAt),
  category: !category ? "-" : getCategoriesFromArray(category),
  featured: booleanToString(banned),
});
